export default __webpack_public_path__ + "static/path-tracer-5cd5af2f9c5921247804d87164cf8127.png";